import { useFormContext } from "react-hook-form";
import { FormField, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { HTMLInputTypeAttribute, ReactNode } from "react";
import { Label } from "@/components/ui/label";

interface FormInputProps {
	name: string;
	label: string;
	type?: HTMLInputTypeAttribute;
	placeholder?: string;
	required?: boolean;
	extraLabelElement?: ReactNode;
	disabled?: boolean;
	autoComplete?: string;
}

export const FormInput = ({
	name,
	label,
	type = "text",
	placeholder,
	required = false,
	disabled = false,
	extraLabelElement,
	autoComplete,
}: FormInputProps) => {
	const { control } = useFormContext();

	return (
		<FormField
			control={control}
			name={name}
			render={({ field }) => (
				<div className="grid gap-2">
					<div className="flex items-center">
						<Label htmlFor={name}>
							{label}
							{required && <span className="text-red-500">*</span>}
						</Label>
						{extraLabelElement && <div className="ml-auto">{extraLabelElement}</div>}
					</div>
					<FormControl>
						<Input
							{...field}
							id={name}
							type={type}
							placeholder={placeholder}
							disabled={disabled}
							required={required}
							autoComplete={autoComplete || name}
						/>
					</FormControl>
					<FormMessage />
				</div>
			)}
		/>
	);
};
